// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Burger__Burger__3K4F-"};